// src/components/ui/Input.jsx
import { C } from '../../styles/tokens';

export default function Input({
  label, error, icon, hint,
  type = 'text', style = {},
  containerStyle = {}, ...props
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', ...containerStyle }}>
      {label && (
        <label style={{ fontSize: '11px', fontWeight: 700, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {icon && (
          <span style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', fontSize: '16px', color: 'rgba(255,255,255,0.3)', pointerEvents: 'none' }}>
            {icon}
          </span>
        )}
        <input
          type={type}
          style={{
            width: '100%',
            padding: icon ? '13px 14px 13px 40px' : '13px 14px',
            background: 'rgba(255,255,255,0.04)',
            border: `1px solid ${error ? C.danger : 'rgba(254,52,232,0.2)'}`,
            borderRadius: '9px',
            color: '#fff',
            fontSize: '14px',
            outline: 'none',
            transition: 'border-color 0.2s',
            fontFamily: "'DM Sans', sans-serif",
            ...style,
          }}
          onFocus={e  => { e.target.style.borderColor = error ? C.danger : C.magenta; }}
          onBlur={e   => { e.target.style.borderColor = error ? C.danger : 'rgba(254,52,232,0.2)'; }}
          {...props}
        />
      </div>
      {hint  && !error && <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)' }}>{hint}</span>}
      {error && <span style={{ fontSize: '12px', color: C.danger }}>{error}</span>}
    </div>
  );
}

export function Textarea({ label, error, hint, style = {}, containerStyle = {}, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', ...containerStyle }}>
      {label && (
        <label style={{ fontSize: '11px', fontWeight: 700, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          {label}
        </label>
      )}
      <textarea
        style={{
          width: '100%', padding: '13px 14px', resize: 'vertical',
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${error ? C.danger : 'rgba(254,52,232,0.2)'}`,
          borderRadius: '9px', color: '#fff', fontSize: '14px',
          outline: 'none', transition: 'border-color 0.2s',
          fontFamily: "'DM Sans', sans-serif", minHeight: '100px',
          ...style,
        }}
        onFocus={e => { e.target.style.borderColor = C.magenta; }}
        onBlur={e  => { e.target.style.borderColor = error ? C.danger : 'rgba(254,52,232,0.2)'; }}
        {...props}
      />
      {error && <span style={{ fontSize: '12px', color: C.danger }}>{error}</span>}
    </div>
  );
}

export function Select({ label, error, children, style = {}, containerStyle = {}, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', ...containerStyle }}>
      {label && (
        <label style={{ fontSize: '11px', fontWeight: 700, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          {label}
        </label>
      )}
      <select
        style={{
          width: '100%', padding: '13px 14px',
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${error ? C.danger : 'rgba(254,52,232,0.2)'}`,
          borderRadius: '9px', color: '#fff', fontSize: '14px',
          outline: 'none', cursor: 'pointer',
          fontFamily: "'DM Sans', sans-serif",
          ...style,
        }}
        {...props}
      >
        {children}
      </select>
      {error && <span style={{ fontSize: '12px', color: C.danger }}>{error}</span>}
    </div>
  );
}
